import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SettingsItem } from '../settingsitem';
import { RadioGroup } from '@tmapy/style-guide';
import { LocaleContext } from '../LocaleContext';
export class TemplateOption extends React.PureComponent {
    render() {
        return this.props.items.length > 1 ? (_jsx(LocaleContext.Consumer, { children: (context) => (_jsx(SettingsItem, { label: context.locale.templateOption, children: _jsx(RadioGroup, { value: this.props.value, items: this.props.items, onChange: this.props.onChange }) })) })) : null;
    }
}
//# sourceMappingURL=component.js.map